import { isNil } from 'lodash'

export default {
    props: {
        value: {
            required: true
        },
        valueName: {
            type: String
        },
        longValueName: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        label: {
            type: String
        },
        icon: {
            type: String
        }
    },

    computed: {
        getValueName() {
            return this.valueName || (isNil(this.value) ? '-' : this.value)
        },
        buttonClass() {
            return {
                'wam-select__button-small': this.longValueName
            }
        }
    },

    methods: {
        handleChange(value) {
            this.$emit('input', value)
            this.$emit('change', value)
        }
    }
}
